var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00001 0C6.19387 0 6.37025 0.112052 6.45262 0.287533L8.03888 3.66669L11.576 4.21032C11.7612 4.23879 11.9149 4.36839 11.9742 4.54609C12.0336 4.72379 11.9887 4.91977 11.8578 5.05383L9.28413 7.6897L9.89249 11.4195C9.92332 11.6085 9.8435 11.7985 9.68695 11.9088C9.5304 12.019 9.32462 12.0302 9.15705 11.9376L6.00001 10.1918L2.84297 11.9376C2.6754 12.0302 2.46962 12.019 2.31308 11.9088C2.15653 11.7985 2.07671 11.6085 2.10753 11.4195L2.71589 7.6897L0.14226 5.05383C0.0113716 4.91977 -0.0335895 4.72379 0.025777 4.54609C0.0851436 4.36839 0.238874 4.23879 0.424056 4.21032L3.96115 3.66669L5.5474 0.287533C5.62978 0.112052 5.80616 0 6.00001 0ZM6.00001 1.67665L4.75312 4.33287C4.68234 4.48366 4.54111 4.58929 4.37647 4.6146L1.53711 5.05099L3.60776 7.17173C3.71867 7.28532 3.76905 7.44483 3.74349 7.60152L3.26028 10.5641L5.75805 9.18284C5.90861 9.09958 6.09141 9.09958 6.24197 9.18284L8.73975 10.5641L8.25653 7.60152C8.23098 7.44483 8.28135 7.28532 8.39226 7.17173L10.4629 5.05099L7.62356 4.6146C7.45891 4.58929 7.31768 4.48366 7.2469 4.33287L6.00001 1.67665Z",
    fill: "#313347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.206ea6d6dc1a2112f851baf794d8ff64.svg";
export { ForwardRef as ReactComponent };